import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  eventsCapacityTitle: {
    id: 'addons.eventsCapacityTitle',
    description: 'AddOn capacity section title',
    defaultMessage: 'Limit available add-on quantity/timeslot',
  },
  eventsCapacitySubtitle: {
    id: 'addons.eventsCapacitySubtitle',
    description: 'Explain assigning add-ons capacity to listings',
    defaultMessage: 'Best for limited-availability items like parking, camping tents, rooms, etc.',
  },
  eventName: {
    id: 'addons.eventName',
    description: 'Event name',
    defaultMessage: 'Event name',
  },
  quantityTimeslot: {
    id: 'addons.quantityTimeslot',
    description: 'Quantity/timeslot',
    defaultMessage: 'Quantity/timeslot',
  },
  capacityInputPlaceholder: {
    id: 'addons.capacityInputPlaceholder',
    description: 'Unlimited',
    defaultMessage: 'Unlimited',
  },
  noEventsFound: {
    id: 'listings.filter.noEventsFound',
    defaultMessage: 'You don’t have any live or draft {currencyCode} events at this time.\n'
     + 'Once {currencyCode} event is created, it will be displayed in this section.',
  },
  createEvent: {
    id: 'listings.createEvent',
    defaultMessage: 'Create event',
  },
  capacityLimitWarningMessage: {
    id: 'addons.capacityLimitWarningMessage',
    description: 'Set capacity limit is higher than available quantity.',
    defaultMessage: 'Set capacity limit is higher than available quantity.'
  },
  zeroLimitErrorMessage: {
    id: 'addons.zeroLimitErrorMessage',
    description: 'Quantity must be higher than 0.',
    defaultMessage: 'Quantity must be higher than 0.'
  },
});

